/*
  Nomadity — cart drawer quick-add ("Complete your trip").
  Loaded as a theme asset so it always executes (inline <script> inside the
  captured cart-drawer children does not run). Uses a single document-level
  delegated click listener, so it survives cart-drawer re-renders.
*/
(function () {
  if (window.__nmQuickAddBound) return;
  window.__nmQuickAddBound = true;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  async function rerenderCartDrawer() {
    try {
      var res = await fetch(root() + '?sections=cart-drawer-section', {
        headers: { Accept: 'application/json' }
      });
      var data = await res.json();
      var html = data['cart-drawer-section'];
      if (!html) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = tmp.querySelector('cart-drawer-component');
      var cur = document.querySelector('cart-drawer-component');
      if (fresh && cur) {
        cur.innerHTML = fresh.innerHTML;
      }
      // Let the theme refresh header count / other cart bubbles.
      try {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (e) {}
    } catch (e) {
      console.warn('[nm quick-add] rerender failed', e);
    }
  }

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('.nm-qa');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('nm-qa--loading')) return;
    var id = Number(btn.getAttribute('data-variant'));
    if (!id) return;
    btn.classList.add('nm-qa--loading');
    try {
      var r = await fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      });
      if (!r.ok) throw new Error('add failed ' + r.status);
      await rerenderCartDrawer();
    } catch (err) {
      console.warn('[nm quick-add] add failed', err);
      btn.classList.remove('nm-qa--loading');
    }
  });
})();
